import {
  RBAC_DEVICE_LIST_VIEW_PERMISSIONS,
  RbacPermissions,
} from './rbac-permissions';

/** Route path (no query) → required permission(s). User needs ANY listed permission. */
export const RBAC_ROUTE_PERMISSIONS: Record<string, string[]> = {
  '/device-list': [...RBAC_DEVICE_LIST_VIEW_PERMISSIONS],
  '/onboarding': [RbacPermissions.Onboarding_Upload_DeviceXLSheet],
  '/ota/device-configuration-list': [RbacPermissions.OTA_ConfigurationList_View],
  '/ota/device-configuration-upload': [RbacPermissions.OTA_UploadConfigurationFile],
  '/ota/device-configuration-history': [
    RbacPermissions.OTA_ConfigurationHistory_View,
  ],
  '/user-management/customers': [RbacPermissions.UserMgmt_Customer_View],
  '/user-management/group-management': [RbacPermissions.UserMgmt_Group_View],
  '/user-management/customer-group-management': [
    RbacPermissions.UserMgmt_GroupAssignment,
  ],
  '/user-management/group-assignment-management': [
    RbacPermissions.UserMgmt_GroupAssignment,
  ],
  '/user-management/role-permission-management': [
    RbacPermissions.UserMgmt_RolePermission,
  ],
  '/user-management/user-list': [RbacPermissions.UserMgmt_UserList_View],
  '/device-details': [
    RbacPermissions.DeviceDetails_Peripherals,
    RbacPermissions.DeviceDetails_DeviceHistory,
    RbacPermissions.DeviceDetails_DeviceConfigHistory,
    RbacPermissions.DeviceDetails_Engineering,
    RbacPermissions.DeviceDetails_DeviceHealth,
    RbacPermissions.DeviceDetails_InstallerLog,
    RbacPermissions.DeviceDetails_SimDetails,
  ],
  '/teal-integration/esim-info': [RbacPermissions.TealInte_SIMInfo],
  '/teal-integration/api-log': [RbacPermissions.TealInte_APILog],
  '/teal-integration/operation-results': [RbacPermissions.TealInte_OperationRes],
};

/** Preferred redirect order when user lacks access to a route. */
export const RBAC_DEFAULT_ROUTE_ORDER: string[] = [
  '/device-list',
  '/device-details',
  '/onboarding',
  '/ota/device-configuration-list',
  '/user-management/customers',
  '/teal-integration/esim-info',
];
